@import "../../global/base.scss";

:host {
    gc-widget-container {
        display: block;
        margin-top: 35px;
        .group {
            margin: 50px 0;
        }

        #video_container {
            position: relative;
            padding-bottom: 56.25%;
            height: 0;

            #video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
}